// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.primary-navigation .primary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	let CloseMenu = document.querySelectorAll('.close-menu');

	if (CloseMenu[0]) {
		CloseMenu[0].addEventListener('click', function (e) {
			document.getElementById('navContainer').classList.remove('open');
			document.getElementById('mobileBurger').classList.remove('open');
		});
	}

	if (document.getElementById('mobileBurger')) {

		document.getElementById('mobileBurger').addEventListener('click', function () {
			document.getElementById('navContainer').classList.toggle('open')
			this.classList.toggle('open');
		})

	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass: 'lbx-gallery',
		// icons: {
		// 	close: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><g data-name="Layer 1"><circle cx="16" cy="16" r="15" style="fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px"/><path d="m10.45 22.93-1.39-1.39 5.55-5.55-5.55-5.55 1.39-1.39L16 14.6l5.55-5.55 1.39 1.39-5.55 5.55 5.55 5.55-1.39 1.39L16 17.38l-5.55 5.55Z" style="fill:#fff"/></g></svg>',
		// 	next: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="56" height="56"><defs><style>.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10}</style></defs><g data-name="Layer 1"><circle cx="28" cy="27.97" r="27.5" style="fill:#1c4a50"/><circle class="cls-3" cx="28" cy="28" r="27.5"/><path data-name="Line 20" class="cls-3" d="M40.66 27.97H10.54"/><path data-name="Polygon 1" d="m43.79 27.97-3.67 2.2v-4.4l3.67 2.2Z" style="fill:#fff"/></g></svg>',
		// 	prev: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="56" height="56"><defs><style>.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10}</style></defs><g data-name="Layer 1"><circle cx="28" cy="28.03" r="27.5" style="fill:#1c4a50"/><circle class="cls-3" cx="28" cy="28" r="27.5"/><path data-name="Line 20" class="cls-3" d="M15.34 28.03h30.12"/><path data-name="Polygon 1" d="m12.21 28.03 3.67-2.2v4.4l-3.67-2.2Z" style="fill:#fff"/></g></svg>'
		// }


	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}